import { OfferReturn } from "@/api/offers";
import { Plan } from "@/api/products";
import { useActiveStore } from "@/store/activePages";
import { usePaymentMethodChangedStore } from "@/store/paymentMethodChanged";
import { useProductStore } from "@/store/product";
import { useEffect, useState } from "react";
import PersonalDataPage from "../personal-data/PersonalDataPage";

export function ProductFromCookie({
  productFromCookie,
  offer,
}: {
  productFromCookie: Plan;
  offer: OfferReturn;
}) {
  const setProduct = useProductStore((store) => store.setProduct);
  const setAreaCode = useProductStore((store) => store.setAreaCode);
  const setLoyalty = useProductStore((store) => store.setLoyalty);
  const setExchangeProhibitedPayment = usePaymentMethodChangedStore(
    (store) => store.setExchangeProhibitedPayment
  );
  const addPage = useActiveStore((store) => store.addPage);
  // So renderiza a tela depois de registrar /personal-data em activePages.
  // Efeitos de filhos rodam antes dos do pai: se a tela montasse junto, o
  // useTabsValidation dela veria a pagina ausente e navegaria para "/".
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setLoyalty(!!offer.fidelidade);
    setExchangeProhibitedPayment(!!offer.proibir_troca_forma_pagamento);
    addPage(`/personal-data`);
    setProduct(productFromCookie);
    setAreaCode(offer.ddd);
    setReady(true);
  }, [
    productFromCookie,
    offer,
    setLoyalty,
    setExchangeProhibitedPayment,
    addPage,
    setProduct,
    setAreaCode,
  ]);

  if (!ready) {
    return null;
  }

  return <PersonalDataPage ignoreCookie />;
}
